<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
<style lang="css">
.rsu {
  font-family: "rsu", sans-serif !important;
  font-size: 1.15rem;
}

.Montserrat {
  font-family: "Montserrat", sans-serif !important;
}

.Kanit {
  font-family: "Kanit", sans-serif !important;
}

.swal2-modal {
  font-family: "PSLKandaModernNewW4Pro", "Kanit", sans-serif !important;
}
@font-face {
  font-family: "PSLKandaModernNewW2Pro";
  src: local("PSLKandaModernNew"),
    url(./assets/fonts/PSLKandaModernNewW2Pro.ttf) format("truetype");
}
@font-face {
  font-family: "PSLKandaModernNewW3Pro";
  src: local("PSLKandaModernNew"),
    url(./assets/fonts/PSLKandaModernNewW3Pro.ttf) format("truetype");
}
@font-face {
  font-family: "PSLKandaModernNewW4Pro";
  src: local("PSLKandaModernNew"),
    url(./assets/fonts/PSLKandaModernNewW4Pro.ttf) format("truetype");
}
.PSLKanda2Pro {
  font-family: "PSLKandaModernNewW2Pro", Helvetica, Arial;
}
.PSLKanda3Pro {
  font-family: "PSLKandaModernNewW3Pro", Helvetica, Arial;
}
.PSLKanda4Pro {
  font-family: "PSLKandaModernNewW4Pro", Helvetica, Arial;
}
</style>
